import React from 'react'
import moment from "moment";
import style from './ExamResult.module.css';

const SolutionTestSeries = ({ exam, filterAndMapQuestions }) => {
            const sectionRanges = {
            "Physics": { start: 1, end: 45 },
            "Chemistry": { start: 46, end: 90 },
            "Biology": { start: 91, end: 180 },
        };
    const getQuestionNumber = (subject, index) => {

        const sectionKey = `${subject}`;
        const sectionRange = sectionRanges[sectionKey];

        if (sectionRange) {
            return sectionRange.start + index; // Adds the index to the start of the section's range
        }

        return null; // If section is not found
    };

    const allQuestions = [];
    for (const subject in sectionRanges) {
        const questions = filterAndMapQuestions(subject); // This should return an array of answers
        const range = sectionRanges[subject];

        if (questions && questions.length) {
            questions.forEach((answer, index) => {
                allQuestions.push({
                    number: range.start + index,
                    answer: answer.correct,
                });
            });
        }
    }

    const chunked = [];
    for (let i = 0; i < allQuestions.length; i += 20) {
        chunked.push(allQuestions.slice(i, i + 20));
    }
    
    return (
        <div>
            <div className='row' style={{ border: '1px solid black', display: 'flex', alignItems: 'center' }}>
                <div className='col-4 d-flex justify-content-center'>
                    <img src='/assets/images/monoarclogo2.jpeg' width='95%' alt='logo' className='my-3' />
                </div>
                <div
                    className='col-5 d-flex flex-column justify-content-center text-center'
                    style={{ borderRight: '1px solid black', borderLeft: '1px solid black', alignSelf: 'stretch', }}
                >
                    <h3 className='fw-bold'>{exam.courseName}</h3>
                </div>
                <div className='col-3 d-flex flex-column justify-content-center fw-bold'>
                    <span>NEET UG</span>
                    <span>{exam.className}</span>
                    <span>Date : {moment(exam.startDate).format('DD MMMM YYYY')}</span>
                </div>
            </div>
            <div className='row'>
                <h4 className="text-center py-1 fw-bold" style={{ borderBottom: '1px solid black' }}>{exam.examName}</h4>
                <h4 className="text-center fw-bold">Answer Key</h4>
            </div>
            <div className='row'>
                <table
                    style={{
                        borderCollapse: 'collapse',
                        tableLayout: 'auto',
                        borderSpacing: 0
                    }}
                >
                    <tbody>
                        {chunked.map((chunk, idx) => (
                            <React.Fragment key={idx}>
                                <tr>
                                    <td className='aq-key' style={{ backgroundColor: '#f0f0f0', border: '1px solid black', fontWeight: 'bold', padding: '4px', whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}>
                                        Q.
                                    </td>
                                    {chunk.map(q => (
                                        <td
                                            key={`q-${q.number}`}
                                            className='aq-key'
                                            style={{ backgroundColor: '#f0f0f0', border: '1px solid black', padding: '4px', whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            {q.number}
                                        </td>
                                    ))}
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid black', fontWeight: 'bold', padding: '4px', whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}>
                                        A.
                                    </td>
                                    {chunk.map(q => (
                                        <td
                                            key={`a-${q.number}`}
                                            style={{ border: '1px solid black', padding: '4px', whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            {q.answer}
                                        </td>
                                    ))}
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
                <h4 className='text-center fw-bold' style={{ borderBottom: '1px solid black' }}>Solutions</h4>
            </div>
            <div className='row' style={{ borderRight: '1px solid black', borderLeft: '1px solid black', borderBottom: '1px solid black' }}>
                {filterAndMapQuestions("Physics") && (
                    <div className='px-0'>
                        <h5 className="text-center fw-bold" style={{ borderBottom: '1px solid black' }}>Physics</h5>
                        {filterAndMapQuestions("Physics").map((q, i) => (
                            <div key={i} className={`px-1 question ${style.questionPaper}`}>
                                <div className="d-flex"
                                    dangerouslySetInnerHTML={{
                                        __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i)}.</span>&nbsp;&nbsp;<span>
                                        <b>Option ( ${q.correct} )</b><br>${q.solution}</span>`,
                                    }}
                                >
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <div className='row' style={{ borderRight: '1px solid black', borderLeft: '1px solid black', borderBottom: '1px solid black' }}>
                {filterAndMapQuestions("Chemistry") && (
                    <div className='px-0'>
                        <h5 className="text-center fw-bold" style={{ borderBottom: '1px solid black' }}>Chemistry</h5>
                        {filterAndMapQuestions("Chemistry").map((q, i) => (
                            <div key={i} className={`px-1 question ${style.questionPaper}`}>
                                <div className="d-flex"
                                    dangerouslySetInnerHTML={{
                                        __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i)}.</span>&nbsp;&nbsp;<span>
                                        <b>Option ( ${q.correct} )</b><br>${q.solution}</span>`,
                                    }}
                                >
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <div className='row' style={{ borderRight: '1px solid black', borderLeft: '1px solid black'}}>
                {filterAndMapQuestions("Biology") && (
                    <div className='px-0'>
                        <h5 className="text-center fw-bold" style={{ borderBottom: '1px solid black' }}>Biology</h5>
                        {filterAndMapQuestions("Biology").map((q, i) => (
                            <div key={i} className={`px-1 question ${style.questionPaper}`}>
                                <div className="d-flex"
                                    dangerouslySetInnerHTML={{
                                        __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i)}.</span>&nbsp;&nbsp;<span>
                                        <b>Option ( ${q.correct} )</b><br>${q.solution}</span>`,
                                    }}
                                >
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default SolutionTestSeries
